module.exports = __webpack_public_path__ + "img/icon_add.c51f5255.svg";